// extracted by mini-css-extract-plugin
export var container = "_c5-0";